/**
 * The nutrition family's public surface: values first, then types.
 *
 * A host mounts `CnutritioncardSet` for the compact tier and
 * `CnutritioncardDetail` for the detail tier. Everything else — the row, the
 * rail card, the three card compositions, the nutrient panel — is internal,
 * because a composition chosen from outside the family is how families
 * re-diverge.
 */
export { Cnutritioncard } from "./Cnutritioncard";
export { CnutritioncardSet } from "./CnutritioncardSet";
export { CnutritioncardDetail } from "./CnutritioncardDetail";

export {
  C_NUTRITION_ASSET_EDGE,
  C_NUTRITION_CARD_VARIANTS,
  C_NUTRITION_CARD_VARIANT_GROUP,
  C_NUTRITION_MICRO_UNIT,
  C_NUTRITION_SERVING_SCOPES,
  C_NUTRITION_SERVING_SCOPE_GROUP,
  DEFAULT_C_NUTRITION_CARD_VARIANT,
  DEFAULT_C_NUTRITION_SERVING_SCOPE,
} from "./cnutritioncard.constants";

export {
  cnutritioncardEnergyLine,
  cnutritioncardKey,
  cnutritioncardMacros,
  cnutritioncardMicros,
  cnutritioncardServingBasis,
} from "./cnutritioncard.model";

export {
  CnutritioncardKind,
  CnutritioncardMicroBasis,
  CnutritioncardMicronutrient,
  CnutritioncardServingScope,
  CnutritioncardVariant,
} from "./cnutritioncard.types";

export type {
  CnutritioncardData,
  CnutritioncardDetailProps,
  CnutritioncardIngredient,
  CnutritioncardMicronutrients,
  CnutritioncardNutrients,
  CnutritioncardProps,
  CnutritioncardRailProps,
  CnutritioncardRowProps,
  CnutritioncardServing,
} from "./cnutritioncard.types";
